module.exports = [{"group":0,"description":"😀"},{"group":1,"description":"👍️"},{"group":2,"description":"🦲"},{"group":3,"description":"🐶"},{"group":4,"description":"🍉"},{"group":5,"description":"🏠️"},{"group":6,"description":"🎁"},{"group":7,"description":"🎶"},{"group":8,"description":"🔝"},{"group":9,"description":"🏁"}]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json
// module id = oaMu
// module chunks = 0